module.exports = __webpack_public_path__ + "static/media/t-alphabet-purple.05f1b7af.svg";